import { canonize } from './validateEmail';

export default canonize;
